<template>
    <div class="settings-internal-plugins">
        <ul class="settings-internal-plugins__list">
            <li
                v-for="(plugin, indexPlugin) in plugins"
                :key="indexPlugin"
                class="settings-internal-plugins__list-item"
            >
                <a :href="plugin.url" :onClick="plugin.call" :target="plugin.target">
                    <CompassIcon
                        v-if="plugin.compassicon"
                        :icon="plugin.compassicon"
                        size="large"
                    />
                    <i v-else :class="plugin.icon" class=""></i>
                    <span class="typographies-paragraph-medium-semibold">{{ plugin.label }}</span>
                </a>
            </li>
        </ul>
        <div v-if="permissions.can_add_module" class="settings-internal-plugins__add-module">
            <CompassButton
                :label="$t.__('settings.SettingsInternalPlugin.add_modules')"
                type="secondary"
                @click="redirectionAddModules"
            />
        </div>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import { createNamespacedHelpers } from 'vuex';
const settingsStore = createNamespacedHelpers('settingsStore');

export default {
    computed: {
        ...settingsStore.mapGetters({
            plugins: 'getInternalPlugins',
            permissions: 'getPermissions',
        }),
    },
    methods: {
        redirectionAddModules() {
            return goToUrl('/?_f=store&amp;showme=apps');
        },
    },
};
</script>

<style lang="scss" scoped>
.settings-internal-plugins {
    &__list {
        display: grid;
        gap: var(--spacing-5);
        grid-template-columns: repeat(6, 1fr);
        margin: 0;

        &-item {
            a {
                align-items: center;
                border-radius: var(--spacing-0);
                color: var(--colors-common-text-subtle-default);
                display: flex;
                flex-direction: column;
                gap: var(--spacing-1);
                height: 100%;
                padding: var(--spacing-1) var(--spacing-2);
                text-align: center;
                text-decoration: none;

                &:hover {
                    background: var(--colors-common-background-hover);
                    color: var(--colors-common-text-subtle-hover);
                }
            }
        }
    }

    &__add-module {
        display: flex;
        justify-content: end;
        padding: var(--spacing-5) 0 0;
    }
}
</style>
